import moment from 'moment'
import axios from 'axios'
// import httpClient from '@/utils/httpClient';

export default {
    methods: {
        incrementStatistic(statName) {
            axios.post('/api/statistics', { name: statName })
        },
        anySearchWasPerformedToday() {
            return localStorage.getItem('search_performed') && moment(localStorage.getItem('search_performed')).format('L') == moment().format('L')
        },
        anySuccessfulSearchWasPerformedToday() {
            return localStorage.getItem('succesful_search_performed') && moment(localStorage.getItem('search_performed')).format('L') == moment().format('L')
        },
        saveSearchDate() {
            localStorage.setItem('search_performed', moment().format('L'))
        },
        saveSuccesfulSearchDate() {
            localStorage.setItem('succesful_search_performed', moment().format('L'))
        }
    },

}